// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .name-form-dialog-content .mat-dialog-container {
  width: 1000px;
}

::ng-deep .form-name-header .mat-dialog-title {
  margin: 0 0 10px;
}

::ng-deep .name-form-dialog-content {
  min-width: 20vw;
}

.form-name-container {
  max-height: calc(65vh - 100px);
  min-height: 20vh;
  overflow: auto;
  table-layout: fixed;
}

.mat-column-select {
  min-width: 50px !important;
}

.cus-matchip {
  min-height: 1px !important;
  align-self: center;
  font-size: 12px;
  color: white !important;
}

.block-section {
  display: flex;
  justify-content: space-between;
}

.lang-header {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 200px;
}

.form-name-container .mat-header-cell,
.mat-footer-cell,
.mat-cell {
  box-sizing: border-box;
}

.no-data {
  background: aliceblue;
  text-align: center;
  font-size: 12px;
  color: gray;
  height: 90%;
  display: flex;
  justify-content: center;
}
.no-data p {
  align-self: center;
}

.form-name-container .mat-table-sticky {
  cursor: pointer;
  opacity: 1;
}

.cdk-drop-list-dragging .cdk-drag {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.cdk-drag-preview {
  opacity: 0;
}

.choice-custom-placeholder {
  background: #ccc;
  width: 264px;
  height: 28px;
  border: dotted 2px #999;
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

th.mat-header-cell {
  text-align: center;
}

th.mat-header-cell:first-of-type, td.mat-cell:first-of-type, td.mat-footer-cell:first-of-type {
  padding-left: 1px;
}

.mat-table tr.mat-row:hover,
.mat-table .mat-row:hover {
  cursor: pointer;
  background-color: white;
}

.form-name-header .mat-dialog-title {
  display: flex;
  justify-content: space-between;
}

.mat-menu-item .mat-icon {
  color: orange;
  margin-right: 8px;
}

.name-btn-menu .mat-icon {
  height: 48px !important;
  width: 48px !important;
  font-size: 48px !important;
}

.menu-tool {
  display: none;
  position: absolute;
  left: 55px;
  top: 24px;
  background: whitesmoke;
  border-radius: 5px;
}
.menu-tool mat-icon {
  font-size: 17px;
  height: 17px;
}
.menu-tool mat-icon:hover {
  background-color: wheat;
}

.menu-disabled {
  display: none;
}

.menu-show {
  display: block;
}

.menu-tricker {
  width: 15%;
  color: gray;
  align-self: flex-end;
  right: 27%;
  margin-bottom: -7px;
}

.trigger {
  height: 40px;
}

.td-select {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.header-menu {
  display: flex;
}
.header-menu mat-select {
  align-self: center;
}
.header-menu mat-icon {
  font-size: medium;
  height: 26px;
}
.header-menu .mat-icon-button {
  width: auto;
}

.add-menus-bar {
  position: sticky;
  left: 0;
}
.add-menus-bar button {
  width: 100%;
  border-style: solid;
  border-width: 1px;
  margin-top: 3px;
  height: 30px;
}

.error-hint {
  font-size: 11px;
  color: white;
  background: #b71c1c;
  width: 100%;
  margin-left: 10px;
  border-radius: 4px;
}

.body-value-column {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.body-value-column .mat-form-field {
  width: 100%;
}

.menus-items-value {
  display: flex;
  flex-direction: column;
}
.menus-items-value mat-icon {
  font-size: 13px;
}

.hide-row {
  display: none;
}

.small-icon-button {
  width: 16px !important;
  height: 16px !important;
  line-height: 1px !important;
}
.small-icon-button .mat-icon {
  width: 13px !important;
  height: 13px !important;
  line-height: 13px !important;
}
.small-icon-button .mat-icon:hover {
  background-color: darkgray;
  border-radius: 10px;
}
.small-icon-button .material-icons {
  font-size: 13px !important;
}

#name-customize-table th {
  background: #80d9e4;
  border-left: 2.5px solid white;
  border-bottom: none;
}

:host .mat-menu-panel .mat-menu-item {
  width: 100%;
}

.header-menu:hover .menu-tool {
  display: block;
}

::ng-deep .form-name-container .mat-table td.mat-cell {
  border: none;
}

::ng-deep .form-name-container .mat-form-field-label {
  font-size: 11px !important;
  font-weight: bold;
}

::ng-deep .form-name-container .mat-form-field-wrapper {
  margin: 0px !important;
  font-size: 11px !important;
  padding-bottom: 1px !important;
}

::ng-deep .form-name-container .mat-form-field-appearance-outline .mat-form-field-infix {
  font-size: 11px !important;
  padding: 8px 1px !important;
  margin-top: -5px;
}

::ng-deep .form-name-container .mat-form-field-appearance-outline .mat-form-field-flex {
  margin-top: 5px;
}

::ng-deep .form-name-container th.mat-header-cell:last-of-type, td.mat-cell:last-of-type, td.mat-footer-cell:last-of-type {
  padding: 0px;
}

::ng-deep .form-name-container .mat-table td.mat-cell, .mat-table td.mat-footer-cell, .mat-table th.mat-header-cell {
  padding: 0 2px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/e-form/dialog/name-customize/name-customize.component.scss"],"names":[],"mappings":"AAAA;EACG,aAAA;AACH;;AAEA;EACG,gBAAA;AACH;;AAEA;EACG,eAAA;AACH;;AAEA;EACG,8BAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AACH;;AAGA;EACG,0BAAA;AAAH;;AAGA;EACG,0BAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;AAAH;;AAGA;EACG,aAAA;EACA,8BAAA;AAAH;;AAGA;EACG,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAAH;;AAGA;;;EAGG,sBAAA;AAAH;;AAGA;EACG,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;AAAH;AACK;EACG,kBAAA;AACR;;AAGA;EACG,eAAA;EACA,UAAA;AAAH;;AAGA;EACG,sDAAA;AAAH;;AAGA;EACG,UAAA;AAAH;;AAGA;EACG,gBAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,sDAAA;AAAH;;AAGA;EACG,kBAAA;AAAH;;AAGA;EACI,iBAAA;AAAJ;;AAGA;;EAEG,eAAA;EACA,uBAAA;AAAH;;AAIG;EACG,aAAA;EACA,8BAAA;AADN;;AAKA;EACG,aAAA;EACA,iBAAA;AAFH;;AAMI;EACE,uBAAA;EACA,sBAAA;EACA,0BAAA;AAHN;;AAOA;EACG,aAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,sBAAA;EACA,kBAAA;AAJH;AAMG;EACG,eAAA;EACA,YAAA;AAJN;AAOG;EACG,uBAAA;AALN;;AASA;EACG,aAAA;AANH;;AASA;EACG,cAAA;AANH;;AASA;EACG,UAAA;EACA,WAAA;EACA,oBAAA;EACA,UAAA;EACA,mBAAA;AANH;;AASA;EACG,YAAA;AANH;;AASA;EACG,aAAA;EACC,mBAAA;EACA,uBAAA;AANJ;;AASA;EACG,aAAA;AANH;AAQG;EACG,kBAAA;AANN;AASG;EACG,iBAAA;EACA,YAAA;AAPN;AAUG;EACG,WAAA;AARN;;AAYA;EACG,gBAAA;EACA,OAAA;AATH;AAUG;EACG,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;AARN;;AAYA;EACG,eAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AATH;;AAYA;EACG,aAAA;EACA,mBAAA;EACA,8BAAA;AATH;AAUG;EACG,WAAA;AARN;;AAYA;EACG,aAAA;EACA,sBAAA;AATH;AAUG;EACG,eAAA;AARN;;AAYA;EACG,aAAA;AATH;;AAYA;EACG,sBAAA;EACA,uBAAA;EACA,2BAAA;AATH;AAWG;EACG,sBAAA;EACA,uBAAA;EACA,4BAAA;AATN;AAYG;EACE,0BAAA;EACD,mBAAA;AAVJ;AAYG;EACG,0BAAA;AAVN;;AAcA;EACG,mBAAA;EACA,8BAAA;EACA,mBAAA;AAXH;;AAcA;EACG,WAAA;AAXH;;AAcA;EACG,cAAA;AAXH;;AAcA;EACG,YAAA;AAXH;;AAcA;EACG,0BAAA;EACA,iBAAA;AAXH;;AAcA;EACG,sBAAA;EACA,0BAAA;EACA,8BAAA;AAXH;;AAcA;EACG,0BAAA;EACA,2BAAA;EACA,gBAAA;AAXH;;AAcA;EACG,eAAA;AAXH;;AAcA;EACG,YAAA;AAXH;;AAcA;EACG,yBAAA;AAXH","sourcesContent":["::ng-deep .name-form-dialog-content .mat-dialog-container {\n   width: 1000px;\n}\n\n::ng-deep .form-name-header .mat-dialog-title {\n   margin: 0 0 10px;\n}\n\n::ng-deep .name-form-dialog-content {\n   min-width: 20vw;\n}\n\n.form-name-container {\n   max-height: calc(65vh - 100px);\n   min-height: 20vh;\n   overflow: auto;\n   table-layout: fixed;\n}\n\n\n.mat-column-select {\n   min-width: 50px !important;\n }\n\n.cus-matchip {\n   min-height: 1px !important;\n   align-self: center;\n   font-size: 12px;\n   color: white !important;\n}\n\n.block-section {\n   display: flex;\n   justify-content: space-between;\n}\n\n.lang-header {\n   overflow: hidden;\n   white-space: nowrap;\n   text-overflow: ellipsis;\n   max-width: 200px;\n}\n\n.form-name-container .mat-header-cell,\n.mat-footer-cell,\n.mat-cell {\n   box-sizing: border-box;\n}\n\n.no-data {\n   background: aliceblue;\n   text-align: center;\n   font-size: 12px;\n   color: gray;\n   height: 90%;\n   display: flex;\n   justify-content: center;\n     p {\n        align-self: center;\n     }\n}\n\n.form-name-container .mat-table-sticky {\n   cursor: pointer;\n   opacity: 1;\n}\n\n.cdk-drop-list-dragging .cdk-drag {\n   transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n }\n\n.cdk-drag-preview {\n   opacity: 0;\n}\n\n.choice-custom-placeholder {\n   background: #ccc;\n   width: 264px;\n   height: 28px;\n   border: dotted 2px #999;\n   transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}\n\nth.mat-header-cell {\n   text-align: center;\n}\n\nth.mat-header-cell:first-of-type, td.mat-cell:first-of-type, td.mat-footer-cell:first-of-type {\n    padding-left: 1px;\n}\n\n.mat-table tr.mat-row:hover,\n.mat-table .mat-row:hover {\n   cursor: pointer;\n   background-color: white;\n}\n\n.form-name-header {\n   .mat-dialog-title {\n      display: flex;\n      justify-content: space-between;\n   }\n}\n\n.mat-menu-item .mat-icon {\n   color: orange;\n   margin-right: 8px;\n}\n\n.name-btn-menu {\n    .mat-icon{\n      height:48px !important;\n      width:48px !important;\n      font-size:48px !important;\n  }\n}\n\n.menu-tool {\n   display: none;\n   position: absolute;\n   left: 55px;\n   top: 24px;\n   background: whitesmoke;\n   border-radius: 5px;\n\n   mat-icon {\n      font-size: 17px;\n      height: 17px;\n   }\n\n   mat-icon:hover {\n      background-color: wheat;\n   }\n}\n\n.menu-disabled {\n   display: none;\n}\n\n.menu-show {\n   display: block;\n}\n\n.menu-tricker {\n   width: 15%;\n   color: gray;\n   align-self: flex-end;\n   right: 27%;\n   margin-bottom: -7px;\n}\n\n.trigger {\n   height: 40px;\n}\n\n.td-select {\n   display: flex;\n    flex-direction: row;\n    justify-content: center;\n}\n\n.header-menu {\n   display: flex;\n\n   mat-select {\n      align-self: center;\n   }\n\n   mat-icon {\n      font-size: medium;\n      height: 26px;\n   }\n\n   .mat-icon-button {\n      width: auto;\n   }\n}\n\n.add-menus-bar {\n   position: sticky;\n   left: 0;\n   button {\n      width: 100%;\n      border-style: solid;\n      border-width: 1px;\n      margin-top: 3px;\n      height: 30px;\n   }\n}\n\n.error-hint {\n   font-size: 11px;\n   color: white;\n   background: #b71c1c;\n   width: 100%;\n   margin-left: 10px;\n   border-radius: 4px;\n}\n\n.body-value-column {\n   display : flex;\n   flex-direction: row;\n   justify-content: space-between;\n   .mat-form-field {\n      width: 100%;\n   }\n}\n\n.menus-items-value {\n   display: flex;\n   flex-direction: column;\n   mat-icon {\n      font-size: 13px;\n   }\n}\n\n.hide-row {\n   display: none;\n}\n\n.small-icon-button {\n   width: 16px !important;\n   height: 16px !important;\n   line-height: 1px !important;\n\n   .mat-icon {\n      width: 13px !important;\n      height: 13px !important;\n      line-height: 13px !important;\n   }\n\n   .mat-icon:hover {\n     background-color: darkgray;\n    border-radius: 10px;\n   }\n   .material-icons {\n      font-size: 13px !important;\n   }\n}\n\n#name-customize-table th {\n   background: #80d9e4;\n   border-left: 2.5px solid white;\n   border-bottom: none;\n}\n\n:host .mat-menu-panel .mat-menu-item {\n   width: 100%;\n}\n\n.header-menu:hover .menu-tool {\n   display: block;\n}\n\n::ng-deep .form-name-container .mat-table td.mat-cell {\n   border: none;\n}\n\n::ng-deep .form-name-container .mat-form-field-label {\n   font-size: 11px !important;\n   font-weight: bold;\n}\n\n::ng-deep .form-name-container .mat-form-field-wrapper {\n   margin: 0px !important;\n   font-size: 11px !important;\n   padding-bottom: 1px !important;\n}\n\n::ng-deep .form-name-container .mat-form-field-appearance-outline .mat-form-field-infix {\n   font-size: 11px !important;\n   padding: 8px 1px !important;\n   margin-top: -5px;\n}\n\n::ng-deep .form-name-container .mat-form-field-appearance-outline .mat-form-field-flex {\n   margin-top: 5px;\n}\n\n::ng-deep .form-name-container th.mat-header-cell:last-of-type, td.mat-cell:last-of-type, td.mat-footer-cell:last-of-type {\n   padding: 0px;\n}\n\n::ng-deep .form-name-container .mat-table td.mat-cell, .mat-table td.mat-footer-cell, .mat-table th.mat-header-cell {\n   padding: 0 2px !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
